export const siteUrl =
	import.meta.env.VITE_SITE_URL ||
	import.meta.env.VITE_BETTER_AUTH_URL ||
	"http://localhost:3000";

const availableOgImageSlugs = new Set([
	"default",
	"blog",
	"help",
	"models",
	"pricing",
	"privacy",
	"security",
	"terms",
]);

export function ogSlugForPath(internalPath: string): string {
	const trimmed = internalPath.replace(/^\//, "").replace(/\/$/, "");
	if (!trimmed) return "default";
	return trimmed.replace(/\//g, "-");
}

export function getLocalizedSeoUrls(_opts: {
	matches?: unknown;
	internalPath: string;
	trailingSlash?: boolean;
}) {
	return {
		canonicalUrl: `${siteUrl}${_opts.internalPath}`,
	};
}

export function ogImageUrl(slug = "default"): string {
	if (availableOgImageSlugs.has(slug)) return `${siteUrl}/og/${slug}.png`;
	if (slug.startsWith("blog-")) return `${siteUrl}/og/${slug}.png`;
	return `${siteUrl}/og/default.png`;
}

export function buildLocalizedSeoLinks(_opts: {
	matches?: unknown;
	internalPath: string;
	trailingSlash?: boolean;
}) {
	return [{ rel: "canonical", href: `${siteUrl}${_opts.internalPath}` }];
}

export function noIndexMeta() {
	return [{ name: "robots", content: "noindex, nofollow" }];
}
